import React, { FC, memo } from 'react';
import { makeStyles } from '@mui/styles';
import { InputBaseProps } from '@mui/material/InputBase';
import NumberFormat from 'react-number-format';
import TextField from '@mui/material/TextField';
import classes from '../FormControlGrey/formControl.module.scss';

type FormControlProps = {
  error?: boolean;
  errorMessage?: string;
} & InputBaseProps;

const inputStyles = (error: FormControlProps['error']) => {
  return {
    padding: '7.5px 10px',
    flex: 1,
    borderRadius: 4,
    border: error ? '1px solid' : 'none',
    borderColor: error ? '#FF7221' : '#E0E7E8',
    height: 34,
    background: '#F3F5F6',
    color: '#444A52',
    // '&:focus': {
    //   borderColor: Color.darkBlue,
    // },
    '&::placeholder': {
      color: '#CACED2',
      opacity: 1,
    },
    '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '&[type=number]': {
      '-moz-appearance': 'textfield',
    },
  };
};

interface NumberFormatCustomProps {
  inputRef: (instance: NumberFormat | null) => void;
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

function NumberFormatCustom(props: NumberFormatCustomProps) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      prefix="+"
      format="+# (###) ###-##-##"
      mask="_"
    />
  );
}

interface State {
  numberformat: string;
}

export const NumberField: FC<FormControlProps> = memo(
  ({ error, errorMessage, ...props }: FormControlProps) => {
    const useStyles = makeStyles({
      root: {
        display: 'flex',
        alignItems: 'center',
        minWidth: 150,
        width: '100%',
        background: '#F3F5F6',
        borderRadius: '4px',
        // height: props.multiline ? 'unset' : 36,
        boxSizing: 'border-box',
        // marginLeft: 25,
      },

      input: {
        fontSize: 16,
        flex: 1,
        display: 'flex',
        '& input': inputStyles(error),
        '& textarea': inputStyles(error),
        width: '100%',
      },
      error: {
        color: '#FF7221',
        fontSize: 14,
        marginTop: 3,
        minHeight: 12,
      },
    });
    const style = useStyles();
    const [values, setValues] = React.useState<State>({
      numberformat: '',
    });

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      setValues({
        ...values,
        [event.target.name]: event.target.value,
      });
    };

    return (
      <div className={classes.container}>
        <TextField
          className={style.root}
          InputProps={{
            ...props,
            inputComponent: NumberFormatCustom as any,
            className: style.input,
            disableUnderline: true,
          }}
        />
      </div>
    );
  },
);
// import PhoneInputReact, { PhoneInputProps } from 'react-phone-input-2';
//
// type PhoneInputPropsType = {
//   onChange: (phone: string) => void;
//   onBlur?: () => void;
//   onFocus?: () => void;
//   inputProps?: PhoneInputProps['inputProps'];
//   error?: boolean;
//   errorMessage?: string;
//   value?: PhoneInputProps['value'];
// };
//
// const containerStyles = {
//   border: 'none !important',
//   borderRadius: '4px !important',
//   '&::before': {
//     background: '#F3F5F6',
//     content: '"+7"',
//     position: 'absolute',
//     left: 40,
//     top: '50%',
//     transform: 'translateY(-50%)',
//     zIndex: 1,
//     color: '#444A52',
//     fontSize: 16,
//   },
// };
//
// const useStyles = makeStyles({
//   containerClass: {
//     // ...containerStyles,
//     position: 'relative',
//     borderColor: `none !important`,
//   },
//   containerClassError: {
//     ...containerStyles,
//     position: 'relative',
//     borderColor: `#EB564F !important`,
//   },
//   inputClass: {
//     border: 'none !important',
//     width: '100% !important',
//     height: '36px !important',
//     fontSize: '16px !important',
//     color: `#444A52 !important`,
//     paddingLeft: '70px !important',
//     '&:focus': {
//       borderColor: 'none',
//     },
//     '&::placeholder': {
//       color: '#CACED2',
//     },
//   },
//   buttonClass: {
//     border: 'none !important',
//     borderRadius: '2px 0 0 2px !important',
//     backgroundColor: `#F3F5F6 !important`,
//     '&:hover .selected-flag': {
//       backgroundColor: `#F3F5F6 !important`,
//     },
//     paddingRight: '25px !important',
//   },
//   error: {
//     color: '#EB564F',
//     fontSize: 12,
//     marginTop: 3,
//   },
// });
//
// export const PhoneInput: FC<PhoneInputPropsType> = ({
//   onChange,
//   onBlur,
//   onFocus,
//   inputProps,
//   error,
//   errorMessage,
//   value,
// }: PhoneInputPropsType): ReactElement => {
//   const classes = useStyles();
//
//   const containerClass = error
//     ? classes.containerClassError
//     : classes.containerClass;
//
//   return (
//     <>
//       <PhoneInputReact
//         disableSearchIcon
//         disableDropdown
//         enableLongNumbers
//         disableCountryCode
//         country="ru"
//         onlyCountries={['ru']}
//         localization={ru}
//         placeholder="+_ (___) ___-__-__"
//         onChange={(phone): void => {
//           if (onChange) {
//             onChange(phone);
//           }
//         }}
//         onBlur={onBlur}
//         onFocus={onFocus}
//         // containerClass={containerClass}
//         inputClass={classes.inputClass}
//         // buttonClass={classes.buttonClass}
//         inputProps={inputProps}
//         // inputProps={{ ...inputProps, autoComplete: 'off' }}
//         value={value || ''}
//       />
//       {error && errorMessage && <p className={classes.error}>{errorMessage}</p>}
//     </>
//   );
// };
